import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarModule } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { ProjectService } from '../../../../common/services/project.service';
import { ProjectSaldo } from '../../../../common/models/project';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-saldo',
  templateUrl: './saldo.component.html',
  styleUrls: ['./saldo.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatChipsModule,
    MatSnackBarModule,
  ]
})
export class SaldoComponent implements OnInit {
  private destroy$ = new Subject<void>();

  projectId!: string;
  saldo: ProjectSaldo | null = null;

  private readonly snackbarConfig: MatSnackBarConfig = {
    duration: 3000,
    horizontalPosition: 'right',
    verticalPosition: 'top'
  };

  constructor(
    private route: ActivatedRoute,
    private projectService: ProjectService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.projectId = this.route.snapshot.paramMap.get('projectId') || '';

    if (this.projectId) {
      this.loadSaldo(this.projectId);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadSaldo(projectId: string) {
    this.projectService.getProjectSaldo(projectId).pipe(takeUntil(this.destroy$)).subscribe({
      next: (saldo: ProjectSaldo) => {
        this.saldo = saldo;
      },
      error: (err) => {
        console.error('Error loading saldo', err);
        this.snackBar.open(
          'Dogodila se greška prilikom učitavanja salda projekta.', 'Zatvori', this.snackbarConfig
        );
      }
    });
  }

  getTotalSaldo(): number {
    return this.saldo?.total || 0;
  }

  getTotalContracted(): number {
    return this.saldo?.items.reduce((sum, item) => sum + item.contractedAmount, 0) || 0;
  }

  getTotalRealized(): number {
    return this.saldo?.items.reduce((sum, item) => sum + item.realizedAmount, 0) || 0;
  }
}